import type { IAdditionalSelectors } from '@makemydeal/dr-activities-tradein';
import { BROWSE_INVENTORY } from '../constants';

export const buildAdditionalSelectors = (additionalSelectors: IAdditionalSelectors): IAdditionalSelectors => {
    const isLoanFlowEnabled = (state: any): boolean =>
        additionalSelectors.configSelectors.isAmdLienPayoffQuoteSpOnSP?.(state) ?? false;

    return {
        dealerSelectors: {
            isTradeValuationKbb: () => true,
            getDealerTradeInValuationProvider: (state: any) =>
                additionalSelectors.dealerSelectors.getDealerTradeInValuationProvider(state) || 'KBB',
            isDealerTradeInLeadFormForWebsiteEnabled: (state: any) =>
                additionalSelectors.dealerSelectors.isDealerTradeInLeadFormForWebsiteEnabled(state) || false,
            isDealerTradeInLeadFormForListingSiteEnabled: (state: any) =>
                additionalSelectors.dealerSelectors.isDealerTradeInLeadFormForListingSiteEnabled(state) || false,
            getDealerState: (state: any) => additionalSelectors.dealerSelectors.getDealerTradeInValuationProvider(state) || 'KBB',
            testDriveAtHomeOnTradeIn: (state: any) => additionalSelectors.dealerSelectors.testDriveAtHomeOnTradeIn(state) || false,
            isVppEnabled: (state: any) => additionalSelectors.dealerSelectors.isVppEnabled(state) || false,
            getCreditProvider: (state: any) =>
                additionalSelectors.dealerSelectors.getDealerTradeInValuationProvider(state) || 'KBB',
            getDealerPhone: (state: any) => additionalSelectors.dealerSelectors.getDealerPhone(state),
            getDealerName: (state: any) => additionalSelectors.dealerSelectors.getDealerName(state) ?? 'Dealer Name',
            hasNoTradeOwnership: (state: any) => additionalSelectors.dealerSelectors.hasNoTradeOwnership(state) || false,
            isSubaruGtpEnabled: (state: any) => additionalSelectors.dealerSelectors.isSubaruGtpEnabled(state),
            getTradeInHideExcellentConditionWebsite: (state: any) =>
                additionalSelectors.dealerSelectors.getTradeInHideExcellentConditionWebsite(state),
            getTradeInHideExcellentConditionListingSite: (state: any) =>
                additionalSelectors.dealerSelectors.getTradeInHideExcellentConditionListingSite(state),
            isGhostVinDealerEnabled: (state: any) => additionalSelectors.dealerSelectors.isGhostVinDealerEnabled(state)
        },
        configSelectors: {
            isP202RedesignEnabled: (state: any) => additionalSelectors.configSelectors.isP202RedesignEnabled(state),
            isActivityEnabled: (state: any) => additionalSelectors.configSelectors.isActivityEnabled(state),
            isGhostVinEnabled: (state: any) => additionalSelectors.configSelectors.isGhostVinEnabled(state),
            isAmdLienPayoffQuoteSpOnSP: isLoanFlowEnabled
        },
        connectionSelectors: {
            getConnectionId: (state: any) => additionalSelectors.connectionSelectors.getConnectionId(state)
        },
        offerSelectors: {
            getHasBeenSent: (state: any) => additionalSelectors.offerSelectors.getHasBeenSent(state) || false,
            getIsOfferBeingSubmitted: (state: any) => additionalSelectors.offerSelectors.getIsOfferBeingSubmitted(state) || false,
            getMonthlyPaymentRoundedByOfferType: (state: any, offerType: any) =>
                additionalSelectors.offerSelectors.getMonthlyPaymentRoundedByOfferType(state, offerType) || 0,
            getCurrentOfferType: (state: any) => additionalSelectors.offerSelectors.getCurrentOfferType(state) || 'lease',
            getShopperInfo: (state: any) => additionalSelectors.offerSelectors.getShopperInfo(state) || { name: '', email: '' },
            getShopperZip: (state: any) => additionalSelectors.offerSelectors.getShopperZip(state) || '',
            isMonthlyPaymentInvalid: (state: any) => additionalSelectors.offerSelectors.isMonthlyPaymentInvalid(state),
            getOfferCreationDateString: (state: any) => additionalSelectors.offerSelectors.getOfferCreationDateString(state),
            getVehicleDetails: (state: any) => additionalSelectors.offerSelectors.getVehicleDetails(state),
            getAnalyticsPayloadVehicleDetails: (state: any) =>
                additionalSelectors.offerSelectors.getAnalyticsPayloadVehicleDetails(state),
            isPaymentInvalid: (payment: any, offerType: any, offerPrice?: any) =>
                additionalSelectors.offerSelectors.isPaymentInvalid(payment, offerType, offerPrice),
            createGatewayOfferPayload: (state: any) => additionalSelectors.offerSelectors.createGatewayOfferPayload(state),
            createOfferPayload: (state: any) => additionalSelectors.offerSelectors.createOfferPayload(state),
            isOfferFromDealer: (state: any) => additionalSelectors.offerSelectors.isOfferFromDealer(state),
            getOfferDealerSource: (state: any) => additionalSelectors.offerSelectors.getOfferDealerSource(state)
        },
        creditSelectors: {
            isCreditAppCompleted: (state: any) => additionalSelectors.creditSelectors.isCreditAppCompleted(state)
        },
        dateFormatters: {
            shortDateString: (date: Date) => additionalSelectors.dateFormatters?.shortDateString(date) || ''
        },
        formatUtils: {
            formatDollars: (dollars) => additionalSelectors.formatUtils?.formatDollars(dollars) || `$${dollars.toString()}`,
            formatDollarsAndCents: (dollars?) =>
                additionalSelectors.formatUtils?.formatDollarsAndCents(dollars) || `$${dollars?.toString() || '0'}`
        },
        vehicleSelectors: {
            getVehicleImageUrl: (state: any) => additionalSelectors.vehicleSelectors?.getVehicleImageUrl(state) || '',
            getVehicleVin: (state: any) => additionalSelectors.vehicleSelectors?.getVehicleVin(state) || ''
        },
        routeSelectors: {
            getCurrentLocation: (state: any) => additionalSelectors.routeSelectors.getCurrentLocation(state),
            isUserRedirectedToManualEntry: (state: any) => additionalSelectors.routeSelectors.isUserRedirectedToManualEntry(state),
            isDDPPage: (state: any) => additionalSelectors.routeSelectors.isDDPPage(state),
            isDealerShowroomExperience: (state: any) =>
                additionalSelectors.routeSelectors.isDealerShowroomExperience(state) || isLoanFlowEnabled(state)
        },
        widgetSelectors: {
            getSponsor: (state: any) => additionalSelectors.widgetSelectors.getSponsor(state) || '',
            isDealerUser: (state: any) => additionalSelectors.widgetSelectors.isDealerUser(state) || false
        },
        uiHelpersUtil: {
            milesToStringShort: (miles: number | string) => additionalSelectors.uiHelpersUtil?.milesToStringShort(miles) || ''
        },
        leadFormInfoSelectors: {
            isOfferSubmitSuccess: (state) => additionalSelectors.leadFormInfoSelectors?.isOfferSubmitSuccess(state) || false,
            isOfferSubmitFailed: (state) => additionalSelectors.leadFormInfoSelectors?.isOfferSubmitFailed(state) || false
        },
        leadForm: {
            onOpenLeadFormModal: (title: string, description: string, skipLink?: boolean, successAction?: string) =>
                additionalSelectors.leadForm?.onOpenLeadFormModal(title, description, skipLink, successAction) || (() => {}),
            onFormSubmit: () => additionalSelectors.leadForm?.onFormSubmit() || (() => {}),
            isLeadFormSubmittedSuccess: (state) => additionalSelectors.leadForm?.isLeadFormSubmittedSuccess(state) || false,
            renderLeadForm: () => additionalSelectors.leadForm?.renderLeadForm() || null
        },
        navigationCardSelectors: {
            getNextCardDetails: (state: any) => additionalSelectors.navigationCardSelectors.getNextCardDetails(state) || {},
            getNextStepInfo: (state: any) =>
                additionalSelectors.navigationCardSelectors.getNextStepInfo(state) || {
                    title: BROWSE_INVENTORY,
                    route: '/'
                },
            getPrevStepInfo: (state: any) =>
                additionalSelectors.navigationCardSelectors.getPrevStepInfo(state) || { title: 'Back', route: '/' }
        },
        menu: {
            getMenuRoutes: () => additionalSelectors.menu.getMenuRoutes() || [],
            menuSelectors: () => additionalSelectors.menu.menuSelectors()
        },
        activitiesStatusSelectors: {
            hideNextActivityFooter: (state: any) => additionalSelectors.activitiesStatusSelectors.hideNextActivityFooter(state),
            isTestDriveServiceUnavailable: (state: any) =>
                additionalSelectors.activitiesStatusSelectors.isTestDriveServiceUnavailable(state)
        },
        paymentSelectors: {
            isCalculatingPayment: (state: any) => additionalSelectors.paymentSelectors.isCalculatingPayment(state)
        },
        editPaymentActivitiesSelectors: {
            messageBox: (actionType: string, state: any, hasMessageBoxBeenClosed: (state: any) => boolean) =>
                additionalSelectors.editPaymentActivitiesSelectors.messageBox(actionType, state, hasMessageBoxBeenClosed)
        },
        tradeInSelectors: {
            getTradeInSource: (state: any) => additionalSelectors.tradeInSelectors.getTradeInSource(state)
        }
    };
};
